module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori-f84608c21107f54316ed8f9e8b8e1c4e.webp";